import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";
import { EMAIL_CHANNEL_PROTOCOLS } from "./constants";

const schema = yup.object({
  id: yup.string().nullable(),
  is_enabled: yup.boolean().nullable(),
  email_address: yup
    .string()
    .max(250, "Email Address cannot be longer than 250 characters.")
    .required("Email Address is required."),
  name: yup
    .string()
    .max(40, "Name cannot be longer than 40 characters.")
    .required("Name is required.")
    .unique(),
  script_id: yup.string().nullable(),
  incoming_mail_server: yup
    .string()
    .max(253, "Incoming Mail Server cannot be longer that 253 characters.")
    .required("Incoming Mail Server is required."),
  protocol: yup
    .string()
    .oneOf(EMAIL_CHANNEL_PROTOCOLS)
    .required("Protocol is required."),
  port: yup
    .number()
    .nullable()
    .min(1, "Port cannot be lower than 1.")
    .max(99999, "Port cannot be higher than 99999.")
    .required("Port is required."),
  incoming_mail_user_id: yup
    .string()
    .max(250, "Incoming Mail User ID cannot be longer than 250 characters.")
    .required("Incoming Mail User ID is required."),
  incoming_mail_password: yup
    .string()
    .max(25, "Incoming Mail Password cannot be longer than 25 characters.")
    .when("id", {
      is: (id) => !id,
      then: (passwordSchema) =>
        passwordSchema.required("Incoming Mail Password is required."),
      otherwise: (passwordSchema) => passwordSchema.nullable(),
    }),
  outgoing_mail_server: yup.string().nullable(),
  outgoing_alternative_credential_enabled: yup.boolean().nullable(),
  outgoing_smtp_server_user_id: yup
    .string()
    .nullable()
    .max(
      250,
      "Outgoing SMTP Server User ID cannot be longer than 250 characters."
    ),
  is_oauth_enabled: yup.boolean().nullable(),
});

addKeyToFieldsRecursively(schema);

export default schema;
